import { LegacyPortalSearchAvailabilityStatus } from "@spwn-portal/grpc/build";

import type { State } from "../../../useFormState/types/states";

const LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_VALUES = new Set(
  Object.values(LegacyPortalSearchAvailabilityStatus)
);
type AvailabilityStatus = State["availabilityStatus"]["checkboxData"][number];

export const extractCheckedAvailabilityStatusId = (
  previousValue: LegacyPortalSearchAvailabilityStatus[],
  availabilityStatus: AvailabilityStatus
): LegacyPortalSearchAvailabilityStatus[] => {
  const { checkboxId, isChecked } = availabilityStatus;
  if (!isChecked) return previousValue;
  const checkboxIdAsNumber = Number(checkboxId);
  if (!LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_VALUES.has(checkboxIdAsNumber))
    return previousValue;
  previousValue.push(checkboxIdAsNumber);
  return previousValue;
};
